import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";
import download from '../images/download-doc.svg';
import "react-daterange-picker/dist/css/react-calendar.css";
import originalMoment from "moment";
import { extendMoment } from "moment-range";
import Divider from '@mui/material/Divider';

import { DesktopDatePicker, LocalizationProvider } from "@mui/lab";
import DateAdapter from "@mui/lab/AdapterDateFns";
import enLocale from "date-fns/locale/en-US";
import frLocale from "date-fns/locale/fr";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { frFR } from '@mui/material/locale';
import { enUS } from '@mui/material/locale';
import SearchableMultiSelect from "../../common/SearchableMultiSelect";
import { getDefaultDateRange, getDateRangeByPreset, formatFromDateForAPI, formatToDateForAPI } from "../../../utils/datetime.utils";
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const localeTheme = createTheme(
  {
   
  },
  localStorage.getItem('i18nextLng') === 'en' ? enUS : frFR,
);

const moment = extendMoment(originalMoment);

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  if (array && array.length <= 0) {
    return [];
  }
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
  return order === "desc"
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}
const rows = [
  { id: "first_name", numeric: false, disablePadding: false, label: "First Name",padding:'10px' },
  { id: "last_name", numeric: false, disablePadding: false, label: "Last Name",padding:'10px' },
  { id: "store_name", numeric: false, disablePadding: false, label: "Store",padding:'10px' },
  { id: "box_name", numeric: false, disablePadding: false, label: "Box",padding:'10px' },
  { id: "rx_no", numeric: false, disablePadding: false, label: "Rx #",padding:'10px' },
  { id: "stocked_date", numeric: false, disablePadding: false, label: "Stock Date" ,padding:'10px'},
  { id: "pickup_date", numeric: false, disablePadding: false, label: "PickUp Date",padding:'10px' },
  { id: "status", numeric: false, disablePadding: false, label: "Status",padding:'10px' },
  { id: "description", numeric: false, disablePadding: false, label: "Description",padding:'10px' }
];

class EnhancedTableHead extends React.Component {
  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const {
      order,
      orderBy,
      t
    } = this.props;

    return (
      <TableHead>
        <TableRow>
          {rows.map(row => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                padding={row.disablePadding ? "none" : "default"}
                sortDirection={orderBy === row.id ? order : false}
                style={{padding:row.padding}}
              >
                <Tooltip
                  title={t("Global.Label.Filter.Sort")}
                  placement={row.numeric ? "bottom-end" : "bottom-start"}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === row.id}
                    direction={order}
                    onClick={this.createSortHandler(row.id)}
                  >
                    {row.label}
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
};


const styles = theme => ({
  root: {
    width: "100%",
    // marginTop: theme.spacing.unit * 3
  },
  table: {
    minWidth: 1020
  },
  tableWrapper: {
    overflowX: "auto"
    // paddingTop:'10%'
  },
  dob: {
    paddingTop: '25px',
  },
  headerdiv:{
    paddingLeft:'15%',
    paddingTop:'10'
}
,
padding10px:{
  padding:'8px'
}
});


let TransactionFilterObj = {
  store_ids:[],
  box_ids:[],
  searchtext:'',
  fromdate:'',
  todate:''
}

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment().tz(timeZone).utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);

    // Set default date range (T-30 days to today)
    const defaultDates = getDefaultDateRange();

    this.state = {
      order: "desc",
      dob: '',
      orderBy: "created_on",
      page: 0,
      rowsPerPage: 10,
      searchtext:'',
      store_id:[],
      box_id:[],
      fromdate: defaultDates.fromDate,
      todate: defaultDates.toDate,
      dateRangePreset: 'last7days',
      isOpen: false,
      startd:moment().format('YYYY-MM-DD'),
      endd:moment().format('YYYY-MM-DD'),
      stores: [],
      boxes:[],
      boxvalues: [],
      accountValues: [],
      nstores:[],
      nboxes:[],
      chipstores:[],
      chipboxes:[],
      locale: localStorage.getItem('i18nextLng') === 'en' ? enLocale : frLocale

   };
    this.handleStoreChange = this.handleStoreChange.bind(this);
    this.handleBoxChange = this.handleBoxChange.bind(this);
  }

  componentDidMount() {
    // Initialize default dates in filter object
    const defaultDates = getDefaultDateRange();
    TransactionFilterObj.fromdate = formatFromDateForAPI(defaultDates.fromDate);
    TransactionFilterObj.todate = formatToDateForAPI(defaultDates.toDate);
    
    fetch(process.env.REACT_APP_BASEURL +  "accounts", {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(accounts => {
      const { t } = this.props;
      let All = [{id: "-1", name: t("Global.Label.DropDown.All")}]
      const storelist = accounts.map(account => {
        return { id: account.id, name: account.name };
      });

       const accountValues = All.concat(storelist);
      this.setState({ accountValues,  parent_account_id: accountValues[0].id });
    });
}

  convertToTimeZone = (requestDate) => {
    const currentUserLang = localStorage.getItem('i18nextLng');
    let zone;
    zone = sessionStorage.getItem('timeZone');
    const date = moment(new Date(requestDate));
    if (['null', null, 'undefined', undefined].includes(zone)) {
      zone = defaultZone;
    }
    return currentUserLang === 'en' ? date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('MM/DD/YYYY hh:mm:ss A') : date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('DD/MM/YYYY hh:mm:ss A');
  }
  exportCSV()
  {

    let csvRow=[];
     let A=[['StoreID','FirstName','LastName','Store','Box','Rx#','StockDate','PickUpDate','Status','Description']];
     let re = this.state !== null ? this.state.data:[];
     if(re !== undefined)
    {
      if(re.length > 0)
      {
        for(let item=0; item < re.length;item++)
        {
              A.push([re[item].first_name,
                re[item].last_name,
                re[item].store_name,
                re[item].box_name,
                re[item].rx_no,
                re[item].stocked_date ? this.convertToTimeZone(re[item].stocked_date) : '' ,
                re[item].pickup_date ? this.convertToTimeZone(re[item].pickup_date) : '' ,
                 re[item].status,
                 re[item].description.replaceAll(',', ' ').trim()
              ]);
        }
       // //  cons
        for(let i=0; i<A.length;++i)
        {
           csvRow.push(A[i].join(","));
        }
        let csvString=csvRow.join("%0A");

        let a=document.createElement("a");
        a.href='data:attachment/csv.'+csvString;
        a.target="_Blank";
        a.download="History.csv";
        document.body.appendChild(a);
        a.click();
      }

    }

  }


  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = "desc";

    if (this.state.orderBy === property && this.state.order === "desc") {
      order = "asc";
    }

    this.setState({ order, orderBy });
  };
  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  };

  //Bind Boxes by store id
  BindBoxesbyStoreId(store_ids){
    if(store_ids.length > 0)
    {
      let BoxesObj = {
        store_ids:store_ids
      }
        fetch(process.env.REACT_APP_BASEURL + 'getBoxesByStoreIds', {
        method: 'post',
        withCredentials: true,
        headers: {
          'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(BoxesObj)
      })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then(data => {
        const { t } = this.props;
         let All = [{id: "-1", name: t("Global.Label.DropDown.All")}]
        const boxlist = data.map(account => {
          return { id: account.id, name: account.name };
        });
         const boxvalues = All.concat(boxlist);
        this.setState({ chipboxes : [] });
        this.setState({ nboxes : [] });
          this.setState({ boxvalues : boxvalues });
      });
     }

  }
  handleStoreChange = event => {
    const storeid=event.target.value;
    const storeids = [];
    let processed = [];
    let chipprocessed = [];
    const AllprocessedIndex = storeid.findIndex(x => x.id === '-1');

    if(AllprocessedIndex > -1)
    {
      chipprocessed = [this.state.accountValues[0]];
      for(let i=0;i< this.state.accountValues.length ;i++)
      {
        processed.push(this.state.accountValues[i]);
      }
    }
    else if(storeid.length === 0)
    {
      chipprocessed=[];
      processed=[];
    }
    else if(storeid.length > 0)
    {
        for (let i = 0; i < event.target.value.length; i++)
        {
          const element = event.target.value[i];
          if(element.id !== '-1')
          {
            chipprocessed.push(element);
            processed.push(element);
          }
        }
    }
    this.setState({ chipstores: chipprocessed });
    this.setState({ nstores: processed });

    if(processed.length > 0)
    {
      for(let i=0;i < processed.length ;i++)
      {
        if(processed[i].id !== '-1')
        {
          storeids.push(processed[i].id)
        }
      }
    }
    this.setState({store_id: storeids});
    this.BindBoxesbyStoreId(storeids);

    this.BindGrid('store',storeids);
  };
  handleBoxChange = event => {
    const boxid=event.target.value;
    const boxids = [];

    let processed = [];
    let chipprocessed = [];
    const AllprocessedIndex = boxid.findIndex(x => x.id === '-1');

    if(AllprocessedIndex > -1)
    {
      chipprocessed = [this.state.boxvalues[0]];
      for(let i=0;i< this.state.boxvalues.length ;i++)
      {
        processed.push(this.state.boxvalues[i]);
      }
    }
    else if(boxid.length === 0)
    {
      chipprocessed=[];
      processed=[];
    }
    else if(boxid.length > 0)
    {
      for (let i = 0; i < event.target.value.length; i++)
        {
          const element = event.target.value[i];
          if(element.id !== '-1')
          {
            chipprocessed.push(element);
            processed.push(element);
          }
        }
    }
    this.setState({ chipboxes: chipprocessed });
    this.setState({ nboxes: processed });

    if(processed.length > 0)
    {
      for(let i=0;i < processed.length ;i++)
      {
        if(processed[i].id !== '-1')
        {
          boxids.push(processed[i].id)
        }
      }
    }

    this.setState({box_id: boxids});
    this.BindGrid('box',boxids);
  };

  handleDeleteStoreChip = (chipToDelete) => (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    if (chipToDelete.id === '-1') {
      this.setState({ chipstores: [], nstores: [], store_id: [] });
      this.BindBoxesbyStoreId([]);
      this.BindGrid('store', []);
      return;
    }
    const updatedStores = this.state.chipstores.filter(chip => chip.id !== chipToDelete.id);
    const updatedNStores = this.state.nstores.filter(store => store.id !== chipToDelete.id);
    this.setState({ chipstores: updatedStores, nstores: updatedNStores });
    const storeids = updatedNStores.filter(s => s.id !== '-1').map(s => s.id);
    this.BindBoxesbyStoreId(storeids);
    this.setState({ store_id: storeids });
    this.BindGrid('store', storeids);
  };

  handleDeleteBoxChip = (chipToDelete) => (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    if (chipToDelete.id === '-1') {
      this.setState({ chipboxes: [], nboxes: [], box_id: [] });
      this.BindGrid('box', []);
      return;
    }
    const updatedBoxes = this.state.chipboxes.filter(chip => chip.id !== chipToDelete.id);
    const updatedNBoxes = this.state.nboxes.filter(box => box.id !== chipToDelete.id);
    this.setState({ chipboxes: updatedBoxes, nboxes: updatedNBoxes });
    const boxids = updatedNBoxes.filter(b => b.id !== '-1').map(b => b.id);
    this.setState({ box_id: boxids });
    this.BindGrid('box', boxids);
  };

  handleClearAllStores = (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    this.setState({ chipstores: [], nstores: [], store_id: [] });
    this.BindBoxesbyStoreId([]);
    this.BindGrid('store', []);
  };

  handleClearAllBoxes = (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    this.setState({ chipboxes: [], nboxes: [], box_id: [] });
    this.BindGrid('box', []);
  };

  //Search Text Box change event
  onSearchChange = (event) => {

    const searchString = event.target.value;
    if (searchString.length > 3) {
      this.setState({ searchtext: searchString && searchString });
      // if(event.target.value.length >=3)
      // {
      this.BindGrid('searchtext', searchString);
      // }
      // else if(event.target.value.length == 0){
      //   this.BindGrid('searchtext',searchString);
      // }
    }
  }
  onFromDateSelect = date => {
    const dateObj = date ? moment(date) : null;
    this.setState({ fromdate: dateObj, dateRangePreset: '' });
    const formattedDate = formatFromDateForAPI(dateObj);
    this.BindGrid('fromdate', formattedDate);
  };
  
  onToDateSelect = date => {
    const dateObj = date ? moment(date) : null;
    this.setState({ todate: dateObj, dateRangePreset: '' });
    const formattedDate = formatToDateForAPI(dateObj);
    this.BindGrid('todate', formattedDate);
  };
  
  handleBlurfrom = (value, date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({
      fromdate: dateObj,
      dateRangePreset: ''
    });
    const formattedDate = formatFromDateForAPI(dateObj);
    this.BindGrid('fromdate', formattedDate);
  }
  
  handleBlurtodate = (value, date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({
      todate: dateObj,
      dateRangePreset: ''
    });
    const formattedDate = formatToDateForAPI(dateObj);
    this.BindGrid('todate', formattedDate);
  }
  
  handleDateRangePresetChange = (event) => {
    const preset = event.target.value;
    if (!preset) return;
    
    const dateRange = getDateRangeByPreset(preset);
    this.setState({
      fromdate: dateRange.fromDate,
      todate: dateRange.toDate,
      dateRangePreset: preset
    });
    
    TransactionFilterObj.fromdate = formatFromDateForAPI(dateRange.fromDate);
    TransactionFilterObj.todate = formatToDateForAPI(dateRange.toDate);
    this.BindGrid('preset', null);
  };

  BindGrid(control,value)
  {
    if(control ==='store')
    {
      TransactionFilterObj.store_ids = value
    }
    else if(control ==='box')
    {
      TransactionFilterObj.box_ids = value;
    }
    else if(control ==='searchtext')
    {
      TransactionFilterObj.searchtext = value;
    }
    else if(control ==='fromdate')
    {
      TransactionFilterObj.fromdate = value;
    }
    else if(control ==='todate')
    {
      TransactionFilterObj.todate = value;
    }
    fetch(process.env.REACT_APP_BASEURL + 'getHistory', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(TransactionFilterObj)
    })
    .then(response => {
      try {
        return response.json();
      } catch (error) {
        return null;
      }
    })
    .then(uData => {
      this.setState({data : uData});
    });
}
getDatebyStatus(date,status){
  let newdate='';
  if(date !== null && status === 'STOCKED')
  {
    newdate = date !== "" ? this.convertToTimeZone(date) : ''
  }
  else if(date !== null && status === 'PICKED_UP')(
    newdate = date !== "" ? this.convertToTimeZone(date) : ''
  )
  return newdate;
}
  render() {
    const { classes, t } = this.props;
    const { data, order, orderBy, rowsPerPage, page, locale, fromdate, todate, dateRangePreset } = this.state;

    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage,  (data ? data.length : 0) - page * rowsPerPage);

    return (
      <Paper className={classes.root}>

      <div>
      <Table className={classes.table} aria-labelledby="tableTitle">
          <TableBody>
              <TableRow >
                        <TableCell style={{width:"30%",borderBottom:"none"}}>
                              <SearchableMultiSelect
                                label="Store"
                                items={this.state.accountValues || []}
                                selectedChips={this.state.chipstores}
                                selectedItems={this.state.nstores}
                                onChange={this.handleStoreChange}
                                onDeleteChip={this.handleDeleteStoreChip}
                                onClearAll={this.handleClearAllStores}
                                placeholder="Search stores..."
                                id="select-multiple-chip-store"
                              />
                        </TableCell>
                        <TableCell style={{width:"30%",borderBottom:"none"}}>
                              <SearchableMultiSelect
                                label="Box"
                                items={this.state.boxvalues || []}
                                selectedChips={this.state.chipboxes}
                                selectedItems={this.state.nboxes}
                                onChange={this.handleBoxChange}
                                onDeleteChip={this.handleDeleteBoxChip}
                                onClearAll={this.handleClearAllBoxes}
                                placeholder="Search locations..."
                                id="select-multiple-chip"
                              />
                        </TableCell>
                        <TableCell style={{width:"15%",borderBottom:"none",paddingTop:"23px"}}>
                          <FormControl sx={{ width: '100%' }}>
                            <InputLabel variant="standard">{t("Global.Label.DropDown.DateRange") || "Date Range"}</InputLabel>
                            <Select
                              value={dateRangePreset}
                              onChange={this.handleDateRangePresetChange}
                              variant="standard"
                              label={t("Global.Label.DropDown.DateRange") || "Date Range"}
                            >
                              <MenuItem value="today">{t("Global.Label.DropDown.Today") || "Today"}</MenuItem>
                              <MenuItem value="last7days">{t("Global.Label.DropDown.Last7Days") || "Last 7 days"}</MenuItem>
                              <MenuItem value="last15days">{t("Global.Label.DropDown.Last15Days") || "Last 15 days"}</MenuItem>
                              <MenuItem value="last30days">{t("Global.Label.DropDown.Last30Days") || "Last 30 days"}</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell style={{width:"17%",borderBottom:"none",paddingTop:"23px"}}>
                        <LocalizationProvider dateAdapter={DateAdapter} locale={locale}>
                                <DesktopDatePicker
                                disableFuture
                                keyboard
                                value={fromdate}
                                renderInput={(params) =>
                                        <TextField
                                        {...params}
                                        label={t("Report.Transaction.FromDate") || "From date"}
                                        variant="standard"
                                        allowKeyboardControl={true}
                                        onBlur={this.handleBlurfrom}
                                        />
                                }
                                onChange={this.onFromDateSelect}
                                />
                            </LocalizationProvider>
                        </TableCell>
                        <TableCell style={{width:"17%",borderBottom:"none",paddingTop:"23px"}}>
                        <LocalizationProvider dateAdapter={DateAdapter} locale={locale}>
                                <DesktopDatePicker
                                disableFuture
                                keyboard
                                value={todate}
                                renderInput={(params) =>
                                        <TextField
                                        {...params}
                                        label={t("Report.Transaction.ToDate") || "To date"}
                                        variant="standard"
                                        allowKeyboardControl={true}
                                        onBlur={this.handleBlurtodate}
                                        />
                                }
                                onChange={this.onToDateSelect}
                                />
                            </LocalizationProvider>
                        </TableCell>
              </TableRow>
              <TableRow>
                  <TableCell style={{width:"30%",borderBottom:"none"}}>
                        <TextField id="idsearchtxt"
                                    defaultValue=""
                                    value={this.state.searchtxt}
                                    label="Search"
                                    onChange={this.onSearchChange}
                                  fullWidth
                                  inputProps={{
                                    autocomplete: 'new-password',
                                    form: {
                                        autocomplete: 'off',
                                    },
                                }}
                                variant="standard"
                                  />
                  </TableCell>
                  <TableCell style={{width:"30%",borderBottom:"none"}}>

                  </TableCell>
                  <TableCell style={{width:"20%",borderBottom:"none"}}>

                  </TableCell>
                  <TableCell style={{width:"25%",borderBottom:"none",textAlign:"right"}}>
                      <img alt="download" onClick={()=>{this.exportCSV()}} src={download} style={{height:'32px',width:'32px',cursor:'pointer'}}/>
                  </TableCell>
              </TableRow>
          </TableBody>
      </Table>
      </div>
      <Divider style={{marginTop:'10px',height:'5px'}}/>
        <div className={classes.tableWrapper}>
         <Table className={classes.table} aria-labelledby="tableTitle">
            <EnhancedTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={this.handleRequestSort}
            />
            <TableBody>
              {!data ? '' : stableSort(data, getSorting(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map(n => {
                  return (
                    <TableRow>
                       <TableCell className={classes.padding10px} >{n.first_name}</TableCell>
                      <TableCell className={classes.padding10px} >{n.last_name}</TableCell>
                      <TableCell className={classes.padding10px} >{n.store_name}</TableCell>
                      <TableCell className={classes.padding10px} >{n.box_name}</TableCell>
                      <TableCell className={classes.padding10px} >{n.rx_no}</TableCell>
                      <TableCell className={classes.padding10px} >{this.getDatebyStatus(n.stocked_date,n.status) }</TableCell>
                      <TableCell className={classes.padding10px} >{this.getDatebyStatus(n.pickup_date,n.status) }</TableCell>
                      <TableCell className={classes.padding10px} >{(n.status !== null && n.status !== "") ? n.status  : ''}</TableCell>
                      <TableCell className={classes.padding10px} style={{width:'20%'}}>{(n.description !== null && n.description !== "") ? n.description  : ''}</TableCell>
                    </TableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow style={{ height: 42 * emptyRows }}>
                  <TableCell colSpan={12} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
        <ThemeProvider theme={localeTheme}>
          <TablePagination
            component="div"
            count={data ? data.length : 0}
            rowsPerPage={rowsPerPage}
            page={page}
            backIconButtonProps={{
              "aria-label": "Previous Page"
            }}
            nextIconButtonProps={{
              "aria-label": "Next Page"
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </ThemeProvider>
      </Paper>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(EnhancedTable);



// WEBPACK FOOTER //
// ./src/components/reports/history/index.js